var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { ewNewMemberInfoResult } from 'boost-api/schemas/ewNewMemberInfoResult';
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
let BoostPortalNavigationView = class BoostPortalNavigationView extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.isSponsorSetup = false;
    }
    static get is() {
        return 'boost-portal-navigation-view';
    }
    static get styles() {
        return css `
            h4 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 20px;
                margin-top: 0;
            }

            a {
                font-size: 125%;
                font-weight: 100;
                color: var(--boost-font-color-dark);
                text-decoration: none;
            }

            .description {
                font-size: 70%;
            }

            :host {
                width: 100%;
            }

            .navigation-card {
                padding: 1rem;
                color: var(--portalCardForeground, #111);
                background-color: var(--portalCardBackground, #fefefe);
                border-radius: 4px;
                cursor: pointer;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
                position: relative;
            }

            .navigation-card:hover {
                background-color: var(--portalCardBackgroundHover, #ececec);
                transition: 300ms ease-out;
            }

            .navigation-container {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }

            .center-name::first-letter {
                text-transform: uppercase;
            }

            @media only screen and (max-width: 800px) {
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this._onConnectedCallback();
    }
    _onConnectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateComplete;
            this.dispatch(BoostPortalStore.Actions.SetDepartments([]));
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(new ewNewMemberInfoResult()));
            this.dispatch(BoostPortalStore.Actions.SetMemberships([]));
            this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId());
            this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId());
            this.dispatch(BoostPortalStore.Actions.SetSponsorCode(''));
            this.dispatch(BoostPortalStore.Actions.SetAvailableDepartments([]));
        });
    }
    /** @override */ render() {
        var _a;
        return html `
            <boost-portal-header @logo-load="${this.requestUpdate}"></boost-portal-header>
            <div style="display:flex; justify-content:center;">
                <div
                    style="max-width: 500px; display:flex; justify-content:center; flex-direction:column; padding:25px;"
                >
                    <h4>${this.boostTranslate('choose-membership-text')}</h4>
                    <div class="navigation-container">
                        <a href="${`${this.centerShort}/member`}">
                            <div class="navigation-card">
                                <div>${this.boostTranslate('become-member')}</div>
                                <div class="description">
                                    ${this.boostTranslate('become-member-description')}
                                </div>
                            </div>
                        </a>
                        <a href="${this.centerShort}/login">
                            <div class="navigation-card">
                                <div>${this.boostTranslate('previously-member')}</div>
                                <div class="description">
                                    ${this.boostTranslate('previously-member-description')}
                                </div>
                            </div>
                        </a>
                        ${this.isSponsorSetup
            ? html `<a href="${this.centerShort}/member/company">
                                      <div class="navigation-card">
                                          <div>${this.boostTranslate('company-sponsored')}</div>
                                          <div class="description">
                                              ${this.boostTranslate('company-code')}
                                          </div>
                                      </div>
                                  </a>

                                  <a href="${this.centerShort}/member/private">
                                      <div class="navigation-card">
                                          <div>${this.boostTranslate('private-sponsored')}</div>
                                          <div class="description">
                                              ${this.boostTranslate('private-sponsored-description')}
                                          </div>
                                      </div>
                                  </a> `
            : nothing}

                        <a href="${this.centerShort}/member/profile">
                            <div class="navigation-card">
                                <div>${this.boostTranslate('create-profile')}</div>
                                <div class="description">
                                    ${this.boostTranslate('create-profile-description')}
                                </div>
                            </div>
                        </a>
                        ${((_a = this.center) === null || _a === void 0 ? void 0 : _a.show_timetable)
            ? html `<a href="${this.centerShort}/classes">
                                  <div class="navigation-card">
                                      <div>Se timeplan</div>
                                      <div class="description">
                                          Se timeplanen til
                                          <span class="center-name">${this.center.title}</span>
                                      </div>
                                  </div>
                              </a>`
            : nothing}
                        ${this.paymentCondition
            ? html ` <a href="${this.centerShort}/vilkar">
                                  <div class="navigation-card">
                                      <div>${this.boostTranslate('payment-policy')}</div>
                                      <div class="description">
                                          ${this.boostTranslate('payment-policy-description')}
                                      </div>
                                  </div>
                              </a>`
            : nothing}
                    </div>
                </div>
            </div>
        `;
    }
};
BoostPortalNavigationView._deps = [BoostPortalHeader];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalNavigationView.prototype, "centerShort", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('center')),
    state(),
    __metadata("design:type", Object)
], BoostPortalNavigationView.prototype, "center", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('isSponsorSetup')),
    state(),
    __metadata("design:type", Boolean)
], BoostPortalNavigationView.prototype, "isSponsorSetup", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('paymentCondition')),
    state(),
    __metadata("design:type", String)
], BoostPortalNavigationView.prototype, "paymentCondition", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('loggedInProfile')),
    state(),
    __metadata("design:type", Object)
], BoostPortalNavigationView.prototype, "loggedInProfile", void 0);
BoostPortalNavigationView = __decorate([
    customElement(BoostPortalNavigationView.is)
], BoostPortalNavigationView);
export { BoostPortalNavigationView };
